import styled from 'styled-components';

export const Body = styled.div`
  padding: 0 1rem;

  &:last-child {
    padding: 0 1rem 1rem 1rem;
  }
`;

export const Content = styled.div`
  padding-bottom: 1rem;

  &:last-child {
    padding-bottom: 0;
  }
`;
